<template>
    <div class="js-entry o-entry c-text-entry">
        <div class="c-text-entry__content" v-html="entryData.Json.Text"></div>
    </div>
</template>

<script>
import { handleUrl } from '@/util/router-guards'
import entryMixin from '../../mixins/entry'

export default {
  mixins: [entryMixin],
  mounted () {
    [...this.$el.querySelector('.c-text-entry__content').getElementsByTagName('a')].forEach(element => {
      element.addEventListener('click', this.onLinkInTextClick)
    })
  },
  methods: {
    onLinkInTextClick (e) {
      e.preventDefault()
      if (e.target.href) {
        const matches = e.target.href.match(/PageID=(\d+)/)
        let url = ''
        if (matches && matches[1]) { url = `/page/${matches[1]}` } else { url = e.target.href }
        handleUrl(url, this.$router)
      }
      this.$el.dispatchEvent(new Event(e.type, e))
    }
  }
}
</script>
